export function formatApiError(detail, error) {
    // Surface server-provided detail if present
    if (detail != null) {
        if (typeof detail === "string") return detail;
        if (Array.isArray(detail)) {
            const parts = detail
                .map((e) => {
                    if (!e) return "";
                    if (typeof e === "string") return e;
                    if (typeof e.msg === "string") {
                        const loc = Array.isArray(e.loc) ? e.loc.filter((p) => p !== "body").join(".") : "";
                        return loc ? `${loc}: ${e.msg}` : e.msg;
                    }
                    try { return JSON.stringify(e); } catch { return String(e); }
                })
                .filter(Boolean);
            if (parts.length) return parts.join(" · ");
        }
        if (typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
    }

    // Fall back to HTTP-status / network hints
    if (error?.response) {
        const status = error.response.status;
        if (status === 413) return "Request too large. Try smaller images.";
        if (status === 401) return "Session expired. Please sign in again.";
        if (status === 403) return "You don't have permission to do that.";
        if (status === 404) return "Not found.";
        if (status >= 500) return `Server error (${status}). Please try again.`;
        return `Request failed (${status}).`;
    }
    if (error?.message === "Network Error") return "Network error — check your internet.";
    if (error?.code === "ERR_NETWORK") return "Network error — check your internet.";
    return "Something went wrong. Please try again.";
}
